export const getFeaturedAd = state => state.featuredAd.data;

export const getIsExpiredFeaturedAd = state => state.featuredAd.isExpired;

export const getAlreadyShownOnce = state => state.featuredAd.alreadyShownOnce;



// WEBPACK FOOTER //
// ./app/FeaturedAd/selectors.js